module.exports = __webpack_public_path__ + "img/value-4.9b8a9f43.svg";